import { IidolGroups } from "../types/idol";

export const IdolGroups: IidolGroups = {
  THEBOYZ: {
    name: "THEBOYZ",
    logo: "https://i.ibb.co/2dYdwQD/THEBOYZ-logo.png",
    slogan: "Best We THE BOYZ! 안녕하세요, 더보이즈입니다!",
    mainPhoto: "https://i.ibb.co/7yFCXM3/theboyz-main.png",
    members: [
      {
        name: "상연",
        birth: "1996. 11. 04.",
        role: "반장,메인보컬",
        img: "https://i.ibb.co/GFKnmTN/theboyz-sy.png",
      },
      {
        name: "제이콥",
        birth: "1997. 05. 30.",
        role: "부반장,리드보컬",
        img: "https://i.ibb.co/jLHzGVG/theboyz-jacob.png",
      },
      {
        name: "영훈",
        birth: "1997. 08. 08.",
        role: "서브보컬",
        img: "https://i.ibb.co/jzXzZgf/theboyz-yh.png",
      },
      {
        name: "현재",
        birth: "1997. 09. 13.",
        role: "리드보컬",
        img: "https://i.ibb.co/4FwfNPc/theboyz-hj.png",
      },
      {
        name: "주연",
        birth: "1998. 01. 11.",
        role: "메인댄서,서브보컬",
        img: "https://i.ibb.co/1rHkGWm/theboyz-jy.png",
      },
      {
        name: "케빈",
        birth: "1998. 02. 23.",
        role: "메인보컬",
        img: "https://i.ibb.co/qC9GbKz/theboyz-kevin.png",
      },
      {
        name: "뉴",
        birth: "1998. 04. 26.",
        role: "메인보컬",
        img: "https://i.ibb.co/g4ZXwNf/theboyz-new.png",
      },
      {
        name: "큐",
        birth: "1998. 11. 05.",
        role: "메인댄서,서브보컬",
        img: "https://i.ibb.co/pX3BGrz/theboyz-q.png",
      },
      {
        name: "주학년",
        birth: "1999. 03. 09.",
        role: "리드댄서,서브보컬",
        img: "https://i.ibb.co/6XFM72C/theboyz-jhn.png",
      },
      {
        name: "선우",
        birth: "2000. 04. 12.",
        role: "메인래퍼,서브보컬",
        img: "https://i.ibb.co/cYrLMXN/theboyz-sw.png",
      },
      {
        name: "에릭",
        birth: "2000. 12. 22.",
        role: "리드래퍼,리드댄서",
        img: "https://i.ibb.co/MhgK2V8/theboyz-eric.png",
      },
    ],
    albums: {
      정규: [
        {
          date: "2020. 02. 10",
          series: "1st ALBUM",
          title: "REVEAL",
          img: "https://i.ibb.co/jZ8bpGh/theboyz-REVEAL.png",
          youtubeLink: "https://www.youtube.com/watch?v=EZntLk9bTUw",
        },
        {
          date: "2023. 08. 07",
          series: "2nd ALBUM",
          title: "PHANTASY",
          etc: "Pt.1 Christmas In August",
          img: "https://i.ibb.co/M9XMs2C/theboyz-phantasy-pt1.png",
          youtubeLink: "https://www.youtube.com/watch?v=w1YuAJFlVRs",
        },
        {
          date: "2023. 11. 20",
          series: "2nd ALBUM",
          title: "PHANTASY",
          etc: "Pt.2 Sixth Sense",
          img: "https://i.ibb.co/w0Bgf7h/theboyz-phantasy-pt2.png",
          youtubeLink: "https://www.youtube.com/watch?v=Nzk-n7lZ7J4",
        },
        {
          date: "2024. 03. 18",
          series: "2nd ALBUM",
          title: "PHANTASY",
          etc: "Pt.3 Love Letter",
          img: "https://i.ibb.co/8b6pxsL/theboyz-phantasy-pt3.png",
          youtubeLink: "https://www.youtube.com/watch?v=CL3F7Cgkaxw",
        },
        {
          date: "2025. 03. 17",
          series: "3rd Album",
          title: "Unexpected",
          img: "https://i.ibb.co/Y7dXQ6TC/theboyz-unexpected.png",
          youtubeLink: "https://www.youtube.com/watch?v=5sulSfWKV4Q",
        },
      ],
      미니: [
        {
          date: "2017. 12. 06",
          series: "DEBUT MINI ALBUM",
          title: "THE FIRST",
          img: "https://i.ibb.co/vBwVBVr/theboyz-the-First.png",
          youtubeLink: "https://www.youtube.com/watch?v=W8CsLhDD5PI",
        },
        {
          date: "2018. 04. 03",
          series: "2nd MINI ALBUM",
          title: "THE START",
          img: "https://i.ibb.co/c6JF8g4/theboyz-the-Start.png",
          youtubeLink: "https://www.youtube.com/watch?v=BM74CO0mOFo",
        },
        {
          date: "2018. 11. 29",
          series: "3rd MINI ALBUM",
          title: "THE ONLY",
          img: "https://i.ibb.co/qBjnc8y/theboyz-the-Only.png",
          youtubeLink: "https://www.youtube.com/watch?v=hJyAuq9r12A",
        },
        {
          date: "2019. 08. 19",
          series: "4th MINI ALBUM",
          title: "DREAMLIKE",
          img: "https://i.ibb.co/bKCDcmm/theboyz-dream-Like.png",
          youtubeLink: "https://www.youtube.com/watch?v=bTTczRe-Pj0",
        },
        {
          date: "2020. 09. 21",
          series: "5th MINI ALBUM",
          title: "CHASE",
          img: "https://i.ibb.co/7jYRSKk/theboyz-chase.png",
          youtubeLink: "https://www.youtube.com/watch?v=c_e-IC0VwZM",
        },
        {
          date: "2021. 08. 09",
          series: "6th MINI ALBUM",
          title: "THRILL-ING",
          img: "https://i.ibb.co/chmxwcj/theboyz-thrill-ing.png",
          youtubeLink: "https://www.youtube.com/watch?v=XMs2CIiqRDI",
        },
        {
          date: "2022. 08. 16",
          series: "7th MINI ALBUM",
          title: "BE AWARE",
          img: "https://i.ibb.co/Y7Wzh9Y/theboyz-be-Aware.png",
          youtubeLink: "https://www.youtube.com/watch?v=pYRSY1Kv3YY",
        },
        {
          date: "2023. 02. 20",
          series: "8th MINI ALBUM",
          title: "BE AWAKE",
          img: "https://i.ibb.co/Tgb3QsZ/theboyz-be-Awake.png",
          youtubeLink: "https://www.youtube.com/watch?v=selkk5MpGVo",
        },
        {
          date: "2024. 10. 28",
          series: "9th MINI ALBUM",
          title: "導火線",
          img: "https://i.ibb.co/Tv5ryDX/theboyz.png",
          youtubeLink: "https://www.youtube.com/watch?v=3T4gA1-sAzI",
        },
      ],
      싱글: [
        {
          date: "2018. 09. 05",
          series: "1st SINGLE ALBUM",
          title: "THE SPHERE",
          img: "https://i.ibb.co/7vdYGRD/theboyz-the-Sphere.png",
          youtubeLink: "https://www.youtube.com/watch?v=Acj9izgg6SY",
        },
        {
          date: "2019. 04. 29",
          series: "2nd SINGLE ALBUM",
          title: "Bloom Bloom",
          img: "https://i.ibb.co/5vXJt4V/theboyz-bloom-Bloom.png",
          youtubeLink: "https://www.youtube.com/watch?v=UFlaP2_j2eA",
        },
        {
          date: "2021. 11. 01",
          series: "3rd SINGLE ALBUM",
          title: "MAVERICK",
          img: "https://i.ibb.co/k3t8r3n/theboyz-maverick.png",
          youtubeLink: "https://www.youtube.com/watch?v=sQTGAggO0Gw",
        },
      ],
      "디지털 싱글": [
        {
          date: "2019. 12. 06",
          series: "Special Single",
          title: "화이트 (White)",
          img: "https://i.ibb.co/4smVKSH/theboyz-white.png",
          youtubeLink: "https://www.youtube.com/watch?v=_VSS0Twtn58",
        },
        {
          date: "2020. 12. 07",
          series: "Special Single",
          title: "Christmassy!",
          img: "https://i.ibb.co/7W5xctH/theboyz-christmassy.png",
          youtubeLink: "https://www.youtube.com/watch?v=dcW47LstjWk",
        },
        {
          date: "2021. 12. 06",
          series: "Special Single",
          title: "Candles",
          img: "https://i.ibb.co/gRC64S9/theboyz-candles.png",
          youtubeLink: "https://www.youtube.com/watch?v=zTyByEFnw2U",
        },
        {
          date: "2022. 12. 06",
          series: "Special Single",
          title: "All About You",
          img: "https://i.ibb.co/B61KSwq/theboyz-all-About-You.png",
          youtubeLink: "https://www.youtube.com/watch?v=YHQmzncbIds",
        },
        {
          date: "2023. 12. 06",
          series: "Special Single",
          title: "Dear.",
          img: "https://i.ibb.co/QYxP9ss/theboyz-dear.png",
          youtubeLink: "https://www.youtube.com/watch?v=Slz1kZrwVh4",
        },
      ],
      기타: [
        {
          date: "2021. 07. 15",
          series: "UNIVERSE MUSIC",
          title: "Drink It ",
          img: "https://i.ibb.co/DD0RRVS/theboyz-Drink-It.png",
          youtubeLink: "https://www.youtube.com/watch?v=ZYi4lmmKRrY",
        },
        {
          date: "2022. 06. 17",
          series: "UNIVERSE MUSIC",
          title: "Sweet",
          img: "https://i.ibb.co/jzZrdbj/theboyz-Sweet.png",
          youtubeLink: "https://www.youtube.com/watch?v=5u3iTD90tZI",
        },
        {
          date: "2023. 04. 23",
          series: "1st Special Single by 뽀로로×더보이즈",
          title: "놀자",
          img: "https://i.ibb.co/h8Lz1vS/theboyz-nolza.png",
          youtubeLink: "https://www.youtube.com/watch?v=trKJY4OoTTs",
        },
      ],
    },
    japanAlbums: {
      정규: [
        {
          date: "2021. 03. 17",
          series: "JAPAN 1st FULL ALBUM",
          title: "Breaking Dawn",
          img: "https://i.ibb.co/BPL60FM/theboyz-breaking-Dawn.png",
          youtubeLink: "https://www.youtube.com/watch?v=c7I57Uv4ilk",
        },
        {
          date: "2023. 06. 13",
          series: "JAPAN 2nd ALBUM",
          title: "Delicious",
          img: "https://i.ibb.co/SmBKdms/theboyz-delicious.png",
          youtubeLink: "https://www.youtube.com/watch?v=wnpNJTYI2kQ",
        },
        {
          date: "2024. 07. 19",
          series: "JAPAN 3rd ALBUM",
          title: "Gibberish",
          img: "https://i.ibb.co/4m0BLfN/theboyz-Gibberish.png",
          youtubeLink: "https://www.youtube.com/watch?v=C9pCpeVfGTc",
        },
      ],
      미니: [
        {
          date: "2019. 11. 06",
          series: "JAPAN 1st MINI ALBUM",
          title: "TATTOO",
          img: "https://i.ibb.co/c3FTY3Z/theboyz-tattoo.png",
          youtubeLink: "https://www.youtube.com/watch?v=gHp42n13nPs",
        },
        {
          date: "2022. 05. 27",
          series: "JAPAN 2nd MINI ALBUM",
          title: "SHE'S THE BOSS",
          img: "https://i.ibb.co/5Krw8R5/theboyz-she-s-The-Boss.png",
          youtubeLink: "https://www.youtube.com/watch?v=rJM6rvz6Ke4",
        },
      ],
      "디지털 싱글": [
        {
          date: "2023. 01. 17",
          series: "FLAGLIA OST",
          title: "Here is",
          img: "https://i.ibb.co/JB3BC6S/theboyz-here-Is.png",
          youtubeLink: "https://www.youtube.com/watch?v=ki1j1AZXXlk",
        },
      ],
    },

    bgColor: "#000000",
    textColor: "#FFFFFF ",
    headerActiveColor: "#D0161D",
    headerActiveTextColor: "#000000",
    memberConColor: "#D0161D",
    memberConTextColor: "#000000",
    albumconbgColor: "#FFFFFF",
    albumcontextColor: "#000000",
  },
  ZEROBASEONE: {
    name: "ZEROBASEONE",
    logo: "https://i.ibb.co/kGjqBm0/zb1-logo4x.png",
    mainPhoto: "https://i.ibb.co/Cb8FnSt/zb1-main.png",
    slogan: "둘, 셋 D1, Be the ONE! 안녕하세요, ZEROBASEONE입니다!",
    members: [
      {
        name: "성한빈",
        img: "https://i.ibb.co/7JrptV0/zb1-shb.png",
        birth: "2001. 06. 13.",
        role: "리더, 보컬, 댄스",
      },
      {
        name: "김지웅",
        img: "https://i.ibb.co/BC1fjLV/zb1-kjw.png",
        birth: "1998. 12. 14.",
        role: "보컬, 래퍼",
      },
      {
        name: "장하오",
        img: "https://i.ibb.co/c67FF3K/zb1-zhao.png",
        birth: "2000. 07. 25.",
        role: "센터, 보컬, 댄서",
      },
      {
        name: "석매튜",
        img: "https://i.ibb.co/frgH5Yr/zb1-smattew.png",
        birth: "2002. 05. 28.",
        role: "보컬, 래퍼",
      },
      {
        name: "김태래",
        img: "https://i.ibb.co/G774CDp/zb1-ktr.png",
        birth: "2002. 07. 14.",
        role: "메인보컬",
      },
      {
        name: "리키",
        img: "https://i.ibb.co/4PMqcCR/zb1-ricky.png",
        birth: "2004. 05. 20.",
        role: "보컬",
      },
      {
        name: "김규빈",
        img: "https://i.ibb.co/ZWcxMnN/zb1-kgv.png",
        birth: "2004. 08. 30.",
        role: "보컬,래퍼",
      },
      {
        name: "박건욱",
        img: "https://i.ibb.co/ZJgJVTp/zb1-pgw.png",
        birth: "2005. 01. 10.",
        role: "보컬,래퍼",
      },
      {
        name: "한유진",
        img: "https://i.ibb.co/2ky0FVk/zb1-hyj.png",
        birth: "2007. 03. 20.",
        role: "보컬, 래퍼",
      },
    ],
    albums: {
      미니: [
        {
          date: "2023. 07. 10",
          series: "The 1st Mini Album",
          title: "YOUTH IN THE SHADE",
          img: "https://i.ibb.co/6NBC8P7/zb1-youth-in-the-shade.png",
          youtubeLink: "https://www.youtube.com/watch?v=trzeUClQIIg",
        },
        {
          date: "2023. 11. 06",
          series: "The 2nd Mini Album",
          title: "MELTING POINT",
          img: "https://i.ibb.co/fHCP1N8/zb1-melting-point.png",
          youtubeLink: "https://www.youtube.com/watch?v=AZoZbtI67Yk",
        },
        {
          date: "2024. 05. 13",
          series: "The 3rd Mini Album",
          title: "You had me at HELLO",
          img: "https://i.ibb.co/4WcPrmX/zb1-you-had-me-at-hello.png",
          youtubeLink: "https://www.youtube.com/watch?v=L9Ts6kiEAts",
        },
        {
          date: "2024. 08. 26",
          series: "The 4th Mini Album",
          title: "CINEMA PARADISE",
          img: "https://i.ibb.co/LZDv1YD/zb1-cinema-paradise.png",
          youtubeLink: "https://www.youtube.com/watch?v=V5ACuj_jOnc",
        },
        {
          date: "2025. 02. 24",
          series: "The 5th Mini Album",
          title: "BLUE PARADISE",
          img: "https://i.ibb.co/8DmxqzSH/zb1-BLUE-PARADISE.png",
          youtubeLink: "https://www.youtube.com/watch?v=2hwiRN8t8Ok",
        },
      ],
      "선공개 싱글": [
        {
          date: "2024. 04. 24",
          series: "Pre-Release Single",
          title: "SWEAT",
          img: "https://i.ibb.co/MkHVWpp/zb1-sweat.png",
          youtubeLink: "https://www.youtube.com/watch?v=6J2tyiQ_V6s",
        },
        {
          date: "2025. 01. 20",
          series: "Pre-Release Single",
          title: "Doctor! Doctor!",
          img: "https://i.ibb.co/dGVM92v/zb1-doctordoctor.webp",
          youtubeLink: "https://www.youtube.com/watch?v=9BXF8gSpEwY",
        },
      ],
    },
    japanAlbums: {
      미니: [
        {
          date: "2025. 01. 29",
          series: "Japan 1st EP",
          title: "PREZENT",
          img: "https://i.ibb.co/C5STvds5/zb1-prezent.webp",
          youtubeLink: "https://www.youtube.com/watch?v=whrNetEPe_M",
        },
      ],
      싱글: [
        {
          date: "2024. 03. 20",
          series: "Japan 1st Single",
          title: "ゆらゆら -運命の花-",
          img: "https://i.ibb.co/vByhPGm/zb1-yura-yura.png",
          youtubeLink: "https://www.youtube.com/watch?v=xx8qT6H8bkM",
        },
      ],
      "디지털 싱글": [
        {
          date: "2024. 05. 17",
          series: "Japan Digital Single",
          title: "Feel the POP",
          etc: "(Japanese version)",
          img: "https://i.ibb.co/Lxs9jb9/zb1-feel-the-pop.png",
          youtubeLink: "https://www.youtube.com/watch?v=zMnCaKnCxkA",
        },
        {
          date: "2024. 08. 30",
          series: "Japan Digital Single",
          title: "GOOD SO BAD",
          etc: "(Japanese version)",
          img: "https://i.ibb.co/LZDv1YD/zb1-cinema-paradise.png",
          youtubeLink: "https://www.youtube.com/watch?v=vawXSe5ZqZ4",
        },
        {
          date: "2024. 10. 11",
          series: "Japan Digital Single",
          title: "Only One Story",
          img: "https://i.ibb.co/VvKL7wr/zb1-only-one-story.png",
          youtubeLink: "https://www.youtube.com/watch?v=9guUZL1Yuv8",
        },
      ],
    },
    bgColor: "#4965C7",
    textColor: "#FFFFFF",
    headerActiveColor: "#1F1CB2",
    headerActiveTextColor: "#FFFFFF",
    memberConColor: "#1F1CB2",
    memberConTextColor: "#FFFFFF",
    albumconbgColor: "#FFFFFF",
    albumcontextColor: "#000000",
  },
  RIIZE: {
    name: "RIIZE",
    logo: "https://i.ibb.co/z7zvxcG/riize-logo4x.png",
    mainPhoto: "https://i.ibb.co/F0fg2CK/riize-main.png",
    slogan: "We RIIZE!",
    members: [
      {
        name: "쇼타로",
        img: "https://i.ibb.co/dWfsJ5b/riize-sho.png",
        birth: "2000. 11. 25.",
        role: "댄서,래퍼",
      },
      {
        name: "은석",
        img: "https://i.ibb.co/J57vTvm/riize-es.png",
        birth: "2001. 03. 19.",
        role: "보컬",
      },
      {
        name: "성찬",
        img: "https://i.ibb.co/cXMTd0F/riize-sc.png",
        birth: "2001. 09. 13.",
        role: "래퍼",
      },
      {
        name: "원빈",
        img: "https://i.ibb.co/qCv8xW4/riize-wb.png",
        birth: "2002. 03. 02.",
        role: "센터, 보컬, 댄서",
      },
      {
        name: "소희",
        img: "https://i.ibb.co/vDW49jp/riize-sh.png",
        birth: "2003. 11. 21.",
        role: "메인보컬",
      },
      {
        name: "앤톤",
        img: "https://i.ibb.co/t8bZnF8/riize-anton.png",
        birth: "2004. 03. 21.",
        role: "보컬",
      },
    ],
    albums: {
      미니: [
        {
          date: "2024. 06. 17",
          series: "The 1st Mini Album",
          title: "RIIZING",
          img: "https://i.ibb.co/VYYwSYT/riize-riizing.png",
          youtubeLink: "https://www.youtube.com/watch?v=78lNnCitcBM",
        },
        {
          date: "2024. 09. 04 (Digital), 2024. 09. 19 (CD)",
          series: "Epilogue EP",
          title: "RIIZING : Epilogue",
          img: "https://i.ibb.co/G3LgdZQ/riize-riizing-epilogue.png",
          youtubeLink: "https://www.youtube.com/watch?v=QflsDwyl2O4",
        },
      ],
      싱글: [
        {
          date: "2023. 09. 04",
          series: "The 1st Single Album",
          title: "Get A Guitar",
          img: "https://i.ibb.co/tLsQ09C/riize-get-a-guitar.png",
          youtubeLink: "https://www.youtube.com/watch?v=iUw3LPM7OBU",
        },
      ],
      "디지털 싱글": [
        {
          date: "2023. 08. 21",
          series: "Prologue Single",
          title: "Memories",
          img: "https://i.ibb.co/1nL6G3V/riize-memories.png",
          youtubeLink: "https://www.youtube.com/watch?v=2H0duKgnYgE",
        },
        {
          date: "2023. 10. 27",
          series: "Digital Single",
          title: "Talk Saxy",
          img: "https://i.ibb.co/w7y0S7h/riize-talk-saxy.png",
          youtubeLink: "https://www.youtube.com/watch?v=gJMheHHf4GQ",
        },
        {
          date: "2024. 01. 05",
          series: "Digital Single",
          title: "Love 119",
          img: "https://i.ibb.co/FVsTpCq/riize-love119.png",
          youtubeLink: "https://www.youtube.com/watch?v=0TAAUWHo4Ec",
        },
        {
          date: "2024. 04. 03",
          series: "Digital Single",
          title: "Siren",
          img: "https://i.ibb.co/pjBrjQk/riize-siren.png",
          youtubeLink: "https://www.youtube.com/watch?v=tZYsvAoSNxQ",
        },
        {
          date: "2024. 04. 18",
          series: "Prologue Single",
          title: "Impossible",
          img: "https://i.ibb.co/G3w15Fm/riize-impossible.png",
          youtubeLink: "https://www.youtube.com/watch?v=Ey53EQhkLY8",
        },
        {
          date: "2025. 01. 08",
          series: "Digital Single",
          title: "Hug",
          img: "https://i.ibb.co/RPVQRc7/riize-hug.webp",
          youtubeLink: "https://www.youtube.com/watch?v=4zve1lFvVQA",
        },
      ],
    },
    japanAlbums: {
      싱글: [
        {
          date: "2024. 07. 29 (Digital), 2024. 09. 05 (CD)",
          series: "The 1st Japan Single",
          title: "Lucky",
          img: "https://i.ibb.co/7KR270H/riize-lucky.png",
          youtubeLink: "https://www.youtube.com/watch?v=3Q49g7M5MlU",
        },
      ],
      "디지털 싱글": [
        {
          date: "2024. 01. 24",
          series: "Digital Single",
          title: "Love 119",
          etc: "(Japanese version)",
          img: "https://i.ibb.co/FVsTpCq/riize-love119.png",
          youtubeLink: "https://www.youtube.com/watch?v=-Y47YS2jr7k",
        },
      ],
    },
    bgColor: "#F0A240",
    textColor: "#000000",
    headerActiveColor: "#000000",
    headerActiveTextColor: "#ffffff",
    memberConColor: "#000000",
    memberConTextColor: "#ffffff",
    albumconbgColor: "#000000",
    albumcontextColor: "#ffffff",
  },
  NCTWISH: {
    name: "NCTWISH",
    logo: "https://i.ibb.co/GHFSF8j/nctwish-logo.png",
    mainPhoto: "https://i.ibb.co/7tq9hZS/nctwish-main.png",
    slogan: `TO THE WORLD, 여기는 NCT!\n 안녕하세요, NCT WISH입니다!`,
    members: [
      {
        name: "시온",
        img: "https://i.ibb.co/86SjFyx/nctwish-sion.png",
        birth: "2002. 05. 11.",
        role: "리더, 보컬, 댄서",
      },
      {
        name: "리쿠",
        img: "https://i.ibb.co/54V4yK6/nctwish-riku.png",
        birth: "2003. 06. 28.",
        role: "댄서, 래퍼",
      },
      {
        name: "유우시",
        img: "https://i.ibb.co/4Z43RRg/nctwish-yushi.png",
        birth: "2004. 04. 05.",
        role: "보컬, 댄서",
      },
      {
        name: "재희",
        img: "https://i.ibb.co/TqLfZ2F/nctwish-jh.png",
        birth: "2005. 06. 21.",
        role: "보컬",
      },
      {
        name: "료",
        img: "https://i.ibb.co/jhM29zq/nctwish-ryo.png",
        birth: "2007. 08. 04.",
        role: "보컬",
      },
      {
        name: "사쿠야",
        img: "https://i.ibb.co/Lxp130Q/nctwish-sakuya.png",
        birth: "2007. 11. 18.",
        role: "래퍼",
      },
    ],
    albums: {
      정규: [
        {
          date: "2024. 11. 27",
          series: "Japan 1st Album",
          title: "WISHFUL",
          img: "https://i.ibb.co/S3jvDMv/nctwish-wishful.png",
          youtubeLink: "https://www.youtube.com/watch?v=NAhEwvI9TGE",
        },
      ],
      미니: [
        {
          date: "2024. 09. 24",
          series: "The 1st Mini Album",
          title: "Steady",
          img: "https://i.ibb.co/xfQc1WH/nctwish-steady.png",
          youtubeLink: "https://www.youtube.com/watch?v=IKlkZZv76Ho",
        },
      ],
      싱글: [
        {
          date: "2024. 02. 28",
          series: "The 1st Single",
          title: "WISH",
          img: "https://i.ibb.co/jhHwqTw/nctwish-wish.png",
          youtubeLink: "https://www.youtube.com/watch?v=hvQZs3k6Ytk",
        },
        {
          date: "2024. 07. 01",
          series: "The 2nd Single",
          title: "Songbird",
          img: "https://i.ibb.co/VWzjhGT/nctwish-songbird.png",
          youtubeLink: "https://www.youtube.com/watch?v=2XqVNFBtVo4",
        },
      ],
      "디지털 싱글": [
        {
          date: "2023. 10. 08",
          series: "Pre-Debut Single",
          title: "Hands Up",
          img: "https://i.ibb.co/MP9g2L2/nctwish-hands-up.png",
          youtubeLink: "https://www.youtube.com/watch?v=ZVcy7bQkBhA",
        },
        {
          date: "2024. 09. 09",
          series: "Pre-Release Single",
          title: "Dunk Shot",
          img: "https://i.ibb.co/xfMxgZh/nctwish-dunk-shot.png",
          youtubeLink: "https://www.youtube.com/watch?v=4vgac97VlCE",
        },
      ],
      "선공개 싱글": [
        {
          date: "2025. 01. 22",
          series: "Pre-Release Single",
          title: "Miracle",
          img: "https://i.ibb.co/H756bgQ/nctwish-miracle.webp",
          youtubeLink: "https://www.youtube.com/watch?v=R319nIK_P4s",
        },
      ],
    },
    bgColor: "#B5E1FD",
    textColor: "#000000",
    headerActiveColor: "#000000",
    headerActiveTextColor: "#FFFFFF",
    memberConColor: "#000000",
    memberConTextColor: "#ffffff",
    albumconbgColor: "#000000",
    albumcontextColor: "#ffffff",
  },
};

export const groupList = Object.keys(IdolGroups);
